import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';

export const schema = z.object({
  fullName: z
    .string()
    .min(3, 'Full name must be at least 3 characters')
    .max(200, 'Full name must be 200 characters or fewer'),
  email: z
    .string()
    .email('Please enter a valid email address')
    .max(320, 'Email must be 320 characters or fewer'),
  rating: z
    .number({ error: 'Please select a rating' })
    .int()
    .min(0)
    .max(4, 'Rating must be between 0 and 4'),
  feedback: z
    .string()
    .max(500, 'Feedback must be 500 characters or fewer')
    .optional(),
});

export type FeedbackFormValues = z.infer<typeof schema>;

export const defaultValues: FeedbackFormValues = {
  fullName: '',
  email: '',
  rating: undefined as unknown as number,
  feedback: '',
};

export const fields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Jane Smith',
    required: true,
    colSpan: 1,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'jane@example.com',
    required: true,
    colSpan: 1,
  },
  {
    name: 'rating',
    type: 'emoji-rating',
    label: 'How was your experience?',
    required: true,
    colSpan: 2,
    dividerBefore: true,
  },
  {
    name: 'feedback',
    type: 'textarea',
    label: 'Tell us more (optional)',
    placeholder: 'Share any additional thoughts…',
    colSpan: 2,
    maxLength: 500,
  },
];
